export function formatTitleSubscription(title: string): string {
  let currentTitle = title;
  if (currentTitle.includes("v2")) {
    currentTitle = currentTitle.split("v2")[0];
  }
  return currentTitle;
}
